import React from "react";
import Slider from "react-slick";
import "./Testimonial.css";
import testimonial from "../../assets/data/testimonal";
import { FaStar, FaRegStar, FaQuoteLeft } from "react-icons/fa";
import { Link } from "react-router-dom";

const Testimonial = () => {
  const settings = {
    dots: true,
    infinite: true,
    centerMode: true,
    centerPadding: "0px",
    speed: 600,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "0px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          arrows: false,
        },
      },
    ],
  };

  return (
    <section className="testimonial-section" id="testimonials">
      {/* Header image + text */}
      <div className="testimonial-title-wrapper">
        <img
          src="https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/UXks7sCBKzljAT69qmhD/media/151ede1c-63db-40f6-9f0f-e2bad80e7637.png"
          alt="Decorative line"
        />
        <h2>What our customer says</h2>
      </div>

      <div className="testimonial-container">
        {/* Left Side: Static text block */}
        <div className="testimonial-left">
          <h3>Client Testimonials</h3>
          <p>
            <strong>Trusted by Personal Injury Law Firms</strong>
          </p>
          <p>
            Our clients rely on Nobel AI Legal to simplify their legal processes
            and improve case outcomes. Here’s what they have to say:
          </p>
          <Link to="/contact" className="consult-button">
            Book A Consultation ➤
          </Link>
        </div>

        {/* Right Side: Animated cards */}
        <div className="testimonial-slider-wrapper">
          <Slider {...settings}>
            {testimonial.map((item, index) => (
              <div key={index} className="testimonial-card">
                <div className="testimonial-content">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="testimonial-image"
                  />
                  <FaQuoteLeft className="testimonial-quote-icon" size={30} />
                  <h3 className="testimonial-name">{item.name}</h3>
                  <p className="testimonial-position">{item.position}</p>
                  <p className="testimonial-quote">"{item.quote}"</p>
                  <div className="testimonial-stars">
                    {[...Array(5)].map((_, i) =>
                      i < item.rating ? (
                        <FaStar key={i} />
                      ) : (
                        <FaRegStar key={i} />
                      )
                    )}
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
